import React,{Component}from 'react';
import { connect } from 'react-redux';
import { Button, Input, Form, Icon} from 'antd';
import './Login.css';
import img from './images/logo.png';
import * as actionCreators from '../service/ClientLinkCreator'

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.submitLogin(values);
            }
        });
    }

    render() {
      const { getFieldDecorator } = this.props.form;
      return (
        <div className="loginDiv">
        <h1 className="login_title">
            <img src={img} alt="logo" className="logoImage" />
            My Link
        </h1>
        {
            this.props.status === 1 && this.props.loginCallBack(this.props.name)
        }
        <Form onSubmit={this.handleSubmit}>
            <Form.Item>
                {getFieldDecorator('userName', {
                    rules: [{ required: true, message: 'Please input your SN / Email / User Name!' }],
                })(
                    <Input className="login_form_item" size="large" prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="SN / Email / User Name" />
                )}
            </Form.Item>
            <Form.Item>
                {getFieldDecorator('password', {
                    rules: [{ required: true, message: 'Please input your Password!' }],
                })(
                    <Input className="login_form_item" size="large" prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
                )}
            </Form.Item>
            <Button type="primary" htmlType="submit" size="large" className="login_form_item">
                Log in
            </Button>
        </Form>
      </div>
      );
    }
  }
  
  const mapState = (state) => {
    return {
        status:state.clientLink.status,
        name:state.clientLink.name,
    }
  }
  
  const mapDispatch = (dispatch) => {
    return {
        submitLogin(values){
            dispatch(actionCreators.login(values))
        }
    }
  }
  
  export default connect(mapState, mapDispatch)(Form.create()(Login));


// WEBPACK FOOTER //
// ./src/layouts/Login.js